import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.account_history.title',
        defaultMessage: 'Your transaction history'
    },
    noAccounts: {
        id: '_.account_history.no_accounts',
        defaultMessage: "You currently don't have any transaction history"
    },
    subTitle: {
        id: '_.account_history.subTitle',
        defaultMessage:
            'This is where you can see your repayments, withdrawals and any other transactions.'
    }
});
